export default "__VITE_ASSET__BNlmFnyc__"